$(function () {
    var body = $('body');
    body.on('click', '.copy_link_icon, #invite_friend_public_url', function () {

        var el = document.getElementById('invite_friend_public_url');
        el.select();
        document.execCommand('copy');
        $('#hs_update_modal_body').find('.copy_link_icon').text($('#hs_update_modal_body').find('.copy_link_icon').data('title_copied'));
        setTimeout(function(){
            $('#hs_update_modal_body').find('.copy_link_icon').text($('#hs_update_modal_body').find('.copy_link_icon').data('title_copy'));
        }, 4000);
    });
});